/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { createEntity, getEntity, reset, updateEntity } from './doctor-details.reducer';

export const DoctorDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const doctorDetailsEntity = useAppSelector(state => state.doctorDetails.entity);
  const loading = useAppSelector(state => state.doctorDetails.loading);
  const updating = useAppSelector(state => state.doctorDetails.updating);
  const updateSuccess = useAppSelector(state => state.doctorDetails.updateSuccess);

  const handleClose = () => {
    navigate(`/doctor-details${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getContactDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.tmPermanent !== undefined && typeof values.tmPermanent !== 'number') {
      values.tmPermanent = Number(values.tmPermanent);
    }
    if (values.createdDtm !== undefined && typeof values.createdDtm !== 'number') {
      values.createdDtm = Number(values.createdDtm);
    }
    if (values.dob !== undefined && typeof values.dob !== 'number') {
      values.dob = Number(values.dob);
    }
    if (values.registrationValidUpto !== undefined && typeof values.registrationValidUpto !== 'number') {
      values.registrationValidUpto = Number(values.registrationValidUpto);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...doctorDetailsEntity,
      ...values,
      contactCode: contactDetails.find(it => it.id.toString() === values.contactCode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...doctorDetailsEntity,
          contactCode: doctorDetailsEntity?.contactCode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorDetails.home.createOrEditLabel" data-cy="DoctorDetailsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorDetails.home.createOrEditLabel">Create or edit a DoctorDetails</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-details-id"
                  label={translate('tinyMedicRestApp.doctorDetails.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.workExperience')}
                id="doctor-details-workExperience"
                name="workExperience"
                data-cy="workExperience"
                type="text"
                validate={{
                  maxLength: { value: 4000, message: translate('entity.validation.maxlength', { max: 4000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.dutyStartTime')}
                id="doctor-details-dutyStartTime"
                name="dutyStartTime"
                data-cy="dutyStartTime"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.dutyEndTime')}
                id="doctor-details-dutyEndTime"
                name="dutyEndTime"
                data-cy="dutyEndTime"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.tmPermanent')}
                id="doctor-details-tmPermanent"
                name="tmPermanent"
                data-cy="tmPermanent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.createdDtm')}
                id="doctor-details-createdDtm"
                name="createdDtm"
                data-cy="createdDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.createdBy')}
                id="doctor-details-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.modifiedBy')}
                id="doctor-details-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.dob')}
                id="doctor-details-dob"
                name="dob"
                data-cy="dob"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.height')}
                id="doctor-details-height"
                name="height"
                data-cy="height"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.weight')}
                id="doctor-details-weight"
                name="weight"
                data-cy="weight"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.registrationCode')}
                id="doctor-details-registrationCode"
                name="registrationCode"
                data-cy="registrationCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.registrationNumber')}
                id="doctor-details-registrationNumber"
                name="registrationNumber"
                data-cy="registrationNumber"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.registrationValidUpto')}
                id="doctor-details-registrationValidUpto"
                name="registrationValidUpto"
                data-cy="registrationValidUpto"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.knownLanguages')}
                id="doctor-details-knownLanguages"
                name="knownLanguages"
                data-cy="knownLanguages"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.qualification')}
                id="doctor-details-qualification"
                name="qualification"
                data-cy="qualification"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.referredBy')}
                id="doctor-details-referredBy"
                name="referredBy"
                data-cy="referredBy"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.bio')}
                id="doctor-details-bio"
                name="bio"
                data-cy="bio"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.timestampentry')}
                id="doctor-details-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.microSec')}
                id="doctor-details-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.lastupdated')}
                id="doctor-details-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.active')}
                id="doctor-details-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.cursor')}
                id="doctor-details-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.practicingCity')}
                id="doctor-details-practicingCity"
                name="practicingCity"
                data-cy="practicingCity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.gender')}
                id="doctor-details-gender"
                name="gender"
                data-cy="gender"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDetails.bloodGroup')}
                id="doctor-details-bloodGroup"
                name="bloodGroup"
                data-cy="bloodGroup"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                id="doctor-details-contactCode"
                name="contactCode"
                data-cy="contactCode"
                label={translate('tinyMedicRestApp.doctorDetails.contactCode')}
                type="select"
                required
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-details" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorDetailsUpdate;
